import { Component } from '@angular/core';
import { getProfile } from 'app/helpers/globals';

@Component({
  selector: 'app-no-data-warning',
  templateUrl: './no-data-warning.component.html',
  styleUrls: ['./no-data-warning.component.scss']
})
export class NoDataWarningComponent {
  get bannerMode(): 'normal' | 'noAds' | 'none' {
    return getProfile().noDriverVehicleBanner;
  }

  get shouldShow(): boolean {
    return this.bannerMode !== 'none';
  }

  get translationKey(): string {
    return this.bannerMode === 'noAds'
      ? 'clientDoesNotHaveAnyVehicleOrDriversNoAds'
      : 'clientDoesNotHaveAnyVehicleOrDrivers';
  }
}
